import React from "react";
import { CommonHeader } from "../../components/commons";
import { ClientDashboardCard } from "../../components/ClientDashboard";
import { connect } from "react-redux";
import { RootState } from "../../redux/rootReducers";
import { useParams } from "react-router-dom";

type AppProps = {
  history: any;
  modules: any[];
};

const ClientSettings = ({ history, modules }: AppProps) => {
  const {id}:any=useParams()
  const company_name = history?.location?.state?.company_name;
  const client_code = history?.location?.state?.client_code ? history?.location?.state?.client_code : id;
  const renderModules = () => {
    window.scrollTo(0, 0);
    let settingsMenu: any =
      modules &&
      modules?.length > 0 &&
      modules?.filter((menu) => menu?.menu_name === "Settings");

    let finalList = settingsMenu[0]?.sub_menu?.map((list: any) => {
      return (
        <div className={`col-md-4 mb-4 ${list.extraClasses}`}>
          <ClientDashboardCard
            isNew={list.is_new}
            key={list.menu_name}
            name={list.menu_name}
            description={list.description}
            icon={<i className={list.icon}></i>}
            action={() => handleRedirection(list.action)}
            comingSoon={list.comingSoon}
          />
        </div>
      );
    });

    return finalList;
  };

  const handleRedirection = (moduleName: string | undefined) => {
    switch (moduleName) {
      case "redirectToAddresses":
        return redirectToAddresses();
      case "redirectToSuppliers":
        return redirectToCustomerSupplierManager();
      case "redirectToAccountsManager":
        return redirectToAccountsManager();
      case "redirectToStockManager":
        return redirectToStockManager();
      case "redirectToDepartment":
        return redirectToDepartment();
      case "redirectToBOMSaveAsTemplate":
        return redirectToBOMSaveAsTemplate();
      case "redirectToGeneralSetting" :
        return redirectToGeneralSetting();
      case "redirectToBatchSetting" :
        return redirectToBatchSetting();
      default:
        return null;
    }
  };

  const redirectToAddresses = () => {
    history.push({
      pathname: `/client-settings/addresses/${client_code}`,
      state: { client_code, company_name },
    });
  };

  const redirectToCustomerSupplierManager = () => {
    history.push({
      pathname: `/client-settings/customers-suppliers/${client_code}`,
      state: { client_code, company_name },
    });
  };

  const redirectToAccountsManager = () => {
    history.push({
      pathname: `/client-settings/accounts-manager/${client_code}`,
      state: { client_code, company_name },
    });
  };

  const redirectToStockManager = () => {
    history.push({
      pathname: `/client-settings/stock-manager/${client_code}`,
      state: { client_code, company_name },
    });
  };

  const redirectToDepartment = () => {
    history.push({
      pathname: `/client-settings/department/${client_code}`,
      state: { client_code, company_name },
    });
  };

  const redirectToBOMSaveAsTemplate = () => {
    history.push({
      pathname: `/client-settings/manufacturing-saved-template/${client_code}`,
      state: { client_code, company_name },
    });
  };

  const redirectToGeneralSetting = () => {
    history.push({
      pathname: `/client-settings/general-setting/${client_code}`,
      state: { client_code, company_name },
    });
  };
  const redirectToBatchSetting = () => {
    history.push({
      pathname: `/client-settings/batch-management/${client_code}`,
      state: { client_code, company_name },
    });
  };

  return (
    <div>
      <CommonHeader
        title="Client Settings"
        company_name={company_name}
        client_code={client_code}
      />
      <div className="row mt-3">{renderModules()}</div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  modules: state.auth.modules,
});

export default connect(mapStateToProps)(ClientSettings);
